import { enableProAnnualMonthlyPaymentPlanP3 } from '@/common/constants';

import { proAnnualMonthlyMarketingCampaignPageLimitedQueries } from '@/views/config/coupon/helper/constant';

export const BILLING_CYCLE_PRIORITY = {
  'annual': 1,
  'annual_term_monthly': 2,
  'monthly': 3,
};

/**
 * Check if current request is from pro annual monthly marketing campaign with limited queries
 * @returns {boolean} Whether it's from limited pro annual monthly marketing campaign
 */
export const proAnnualMonthlyMarketingCampaignLimited = () => {
  return !enableProAnnualMonthlyPaymentPlanP3 && proAnnualMonthlyMarketingCampaignPageLimitedQueries.some((key) => window.$config(key));
};
